import { Box } from '@material-ui/core';

import { OnboardingAuthLayoutProps } from 'src/legacy/components/Onboarding/Login/OnboardingAuthLayout';
import { OnboardingFormCard } from 'src/legacy/components/Onboarding/OnboardingFormCard';
import {
  MfaFormProps,
  OnboardingForgotPasswordForm,
} from 'src/legacy/components/Onboarding/OnboardingForms/OnboardingForgotPasswordForm';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { CopilotAvatar } from 'src/legacy/components/UI/Avatars/CopilotAvatar';

type OnboardingForgotPasswordPageProps = OnboardingAuthLayoutProps &
  MfaFormProps;

export const OnboardingForgotPasswordPage = ({
  onAuthComplete,
  onMfaRequired,
}: OnboardingForgotPasswordPageProps) => (
  <OnboardingFormCard>
    <CopilotAvatar />
    <Box mt={1.5} mb={5} textAlign="center" px={{ xs: 2, sm: 0 }}>
      <BaseTypography fontType="18Medium">Reset your password</BaseTypography>
    </Box>
    <Box mt={-2.5}>
      <OnboardingForgotPasswordForm
        onAuthComplete={onAuthComplete}
        onMfaRequired={onMfaRequired}
      />
    </Box>
  </OnboardingFormCard>
);
